<template>
 <div>
   <div  ref="searchBox">
     <div class="detailsTitle">
        <h4>库存明细</h4>
        <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class=" inpBox">
              <el-form-item label="货物类型:" class="jiage" prop="productType">
                <el-select  v-model="searchFrom.productType"   placeholder="请选择">
                  <el-option v-for="item in productTypes" :label="item.show_name" :value="item.item_no" :key="item.item_no"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货权方:" prop="ownerCustomerName">
                <el-input  placeholder="" v-model="searchFrom.ownerCustomerName"></el-input>
              </el-form-item>
               <el-form-item label="产地:" prop="steelMillName">
                <el-input  placeholder="" v-model="searchFrom.steelMillName"></el-input>
              </el-form-item>
               <el-form-item label="材质:" prop="model">
                <el-input  placeholder="" v-model="searchFrom.model"></el-input>
              </el-form-item>
               <el-form-item label="规格:" prop="specification">
                <el-input  placeholder="" v-model="searchFrom.specification"></el-input>
              </el-form-item>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">总件数：<span class="red">{{tongji.totalNumber}}</span>件</p>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">总重量：<span class="red">{{tongji.totalAllWeight}}</span>吨</p>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="ownerCustomerName"  min-width="200" :formatter="emptyFn" label="货权方"></el-table-column>
        <el-table-column property="productTypeName"  width="100" label="货物类型"></el-table-column>
        <el-table-column property="steelMillName" width="200"  label="产地"></el-table-column>
        <el-table-column property="specification" width="100"  label="规格"></el-table-column>
        <el-table-column property="model" width="120" label="材质"></el-table-column>
        <!-- <el-table-column property="root" width="120"  :formatter="emptyFn"   label="单件支数"></el-table-column>
        <el-table-column property="length"  width="100"  :formatter="emptyFn"  label="长度(m)"></el-table-column> -->
        <el-table-column property="number" width="120" :formatter="emptyFn"  label="总件数"></el-table-column>
        <el-table-column property="singletonWeight" width="130"   label="单件理重(吨)"></el-table-column>
        <el-table-column property="allWeight" width="130"   label="总重量(吨)"></el-table-column>
        <el-table-column property="stockWeight" width="130"   label="总理重(吨)"></el-table-column>
        <el-table-column property="stockPoundWeight" min-width="130"    label="总磅重(吨)"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { getDictionaryAll, getStockThreadList, getStockThreadTotalWN } from '@/api/soc-stock-cosco'
export default {
  data () {
    let oneCustomerTaxId = this.$route.query.oneCustomerTaxId
    let twoCustomerTaxId = this.$route.query.twoCustomerTaxId
    let organizationId = this.$route.query.organizationId
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      organizationId: organizationId,
      twoCustomerTaxId: twoCustomerTaxId,
      oneCustomerTaxId: oneCustomerTaxId,
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        organizationId: organizationId,
        twoCustomerTaxId: twoCustomerTaxId,
        oneCustomerTaxId: oneCustomerTaxId
      },
      total: 0,
      tongji: {},
      loading: 'false',
      productTypes: [],
      warehouseList: []
    }
  },
  created () {
    getDictionaryAll({ groupNo: 'thread_product_type' }).then(res => {
      this.productTypes = res
      this.productTypes.unshift({ show_name: '全部', item_no: '' })
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      getStockThreadList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      getStockThreadTotalWN(searchFrom).then(res => {
        this.tongji = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        organizationId: this.organizationId,
        twoCustomerTaxId: this.twoCustomerTaxId,
        oneCustomerTaxId: this.oneCustomerTaxId
      }
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.searchBox /deep/.el-form-item{
  display: flex;
}
</style>
